import { Component, OnInit } from '@angular/core';
import { UserService } from '../auth/user.service';
import { MsalService } from '@azure/msal-angular';
import { HealthService } from '../health/health.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  display: boolean;

  loggedIn = false;
  isTdbUser: boolean = false;
  username: string;

  constructor(
    private userService: UserService,
    private authService: MsalService,
    private healthService: HealthService,
  ) { }

  ngOnInit() {
    
    let accounts = this.authService.instance.getAllAccounts();

    this.loggedIn = accounts.length > 0;

    this.userService.storeUserName(accounts[0].name);

    this.userService.storeIsTdbUser(this.userService.checkTdbUser());

    this.userService.getCompany().subscribe(company => {

      if (this.userService.isTdbUser()) {
        this.userService.storeDealerNumber(null);
      } else {
        this.userService.storeDealerNumber(company.value);
      }

    });

    this.username = this.userService.getUserName();
    this.isTdbUser = this.userService.isTdbUser();

    this.healthService.healthCheck().subscribe(
      success => { this.display = false; },
      err => { this.display = true; }
    );
  }

  logout() {
    this.userService.logout();
  }

  login() {

  }

}